import { AlfaKodeOversiktResponse } from '../../models/NV06AlfaOversikt';
import * as actionTypesNV06 from './actionTypesNV06';

export const fetchAlfaOversiktRequest = (
  companyId: number,
  page: number,
  pageSize: number,
  search?: string,
  sortBy?: string,
  sortDirection?: string,
) => ({
  type: actionTypesNV06.NV06_ALFA_OVERSIKT_GET,
  payload: { companyId, page, pageSize, search, sortBy, sortDirection },
});

export const fetchAlfaOversiktSuccess = (data: AlfaKodeOversiktResponse) => ({
  type: actionTypesNV06.NV06_ALFA_OVERSIKT_SUCCESS,
  payload: data,
});

export const fetchAlfaOversiktFailure = (error: string) => ({
  type: actionTypesNV06.NV06_ALFA_OVERSIKT_FAILURE,
  payload: error,
});

export const resetNV06 = () => ({
  type: actionTypesNV06.NV06_RESET,
});
